module.exports = __webpack_public_path__ + "static/erin-doyle_800x800-444c0d1eaa518fa48b4b9472b394ea37.png";